export function normalizeHeader(s) {
  return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]/g, '');
}

export const TARGET_FIELDS = [
  { key: 'patient_name', label: 'Patient name', required: true },
  { key: 'email', label: 'Email', required: false },
  { key: 'tel_num', label: 'Cell phone', required: false },
  { key: 'home_phone', label: 'Home phone', required: false },
  { key: 'dob', label: 'Date of birth', required: true },
  { key: 'type', label: 'Type', required: true },
  { key: 'EHR_ID', label: 'EHR ID', required: true },
  { key: 'physician_name', label: 'Physician', required: false },
  { key: 'date_', label: 'Visit date', required: false },
  { key: 'time_', label: 'Visit time', required: false },
];

export const NAME_PART_KEYS = ['name_first', 'name_middle', 'name_last'];

export const ADDRESS_PART_KEYS = ['addr_street', 'addr_apt', 'addr_city', 'addr_state', 'addr_zip'];

export const SYNONYMS = {
  patient_name: ['patientname', 'name', 'patname', 'ptname', 'fullname', 'patient', 'patientfullname'],
  email: ['email', 'emailaddr', 'emailaddress', 'mail', 'eaddr'],
  // tel_num is the cell (every SMS goes to it); home numbers have their own
  // field so a sheet with both no longer loses one. A generic "Phone" stays on
  // tel_num. No bare 'home' synonym: it would pull in "Home Address".
  tel_num: ['phone', 'phonenumber', 'phoneno', 'tel', 'telephone', 'telnum', 'mobile', 'mobilephone', 'mobilenumber', 'cell', 'cellphone', 'cellnumber', 'cellphonenumber', 'contact', 'contactnumber'],
  home_phone: ['homephone', 'hmphone', 'homephonenumber', 'homenumber', 'homeno', 'hometel', 'hometelephone', 'hmtel', 'landline', 'residencephone', 'housephone'],
  dob: ['dob', 'birthdt', 'birthdate', 'dateofbirth', 'birthday', 'born'],
  type: ['type', 'visittype', 'patienttype', 'category', 'encountertype'],
  EHR_ID: ['ehrid', 'ehr', 'mdrc', 'mrn', 'medicalrecord', 'medicalrecordnumber', 'recordnumber', 'recordid', 'chart', 'chartnumber', 'patientid', 'ptid', 'accountnumber', 'acctno'],
  physician_name: ['physician', 'physicianname', 'doctor', 'doctorname', 'md', 'provider', 'providername', 'referringmd', 'referringphysician', 'attending', 'pcp'],
  date_: ['date', 'visitdate', 'dos', 'dateofservice', 'servicedate', 'encounterdate', 'appointmentdate', 'apptdate'],
  time_: ['time', 'visittime', 'appointmenttime', 'appttime', 'timeofservice'],
  name_first: ['first', 'firstname', 'fname', 'givenname', 'given'],
  name_middle: ['middle', 'middlename', 'mi', 'middleinitial'],
  name_last: ['last', 'lastname', 'lname', 'surname', 'familyname', 'family'],
  addr_street: ['address', 'addr', 'street', 'streetaddress', 'addressline1', 'address1', 'addr1', 'line1', 'mailingaddress'],
  addr_apt: ['apt', 'apartment', 'unit', 'suite', 'ste', 'aptno', 'unitno', 'addressline2', 'address2', 'addr2', 'line2'],
  addr_city: ['city', 'town', 'municipality'],
  addr_state: ['state', 'province', 'region'],
  addr_zip: ['zip', 'zipcode', 'postal', 'postalcode', 'postcode'],
};
